import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import Modal from '../Modal';
import SheetHeader from './SheetHeader';
import SheetBody from './SheetBody';
import SheetFooter from './SheetFooter';

export default function Sheet({
  isOpen = false,
  isProcessing = false,
  onEnter = () => {},
  onExit = () => {},
  onClose = () => {},
  onOpened = () => {},
  onClosed = () => {},
  children = null,
  className = '',
  wrapClassName = '',
  modalClassName = '',
  contentClassName = '',
  activeBaseClassName = '',
  ...reactstrapModalProps
}) {
  return (
    <Modal
      zIndex={10000}
      isOpen={isOpen}
      isProcessing={isProcessing}
      onEnter={onEnter}
      onExit={onExit}
      onClose={onClose}
      onOpened={onOpened}
      onClosed={onClosed}
      wrapClassName={cn(styles.wrapper, wrapClassName)}
      modalClassName={cn(styles.modal, modalClassName)}
      className={cn(styles.container, className)}
      contentClassName={cn(styles.content, contentClassName)}
      modalTransition={{
        timeout: 300,
        appear: false,
        baseClass: styles.modal,
        baseClassActive: styles.show
      }}
      {...reactstrapModalProps}
    >
      {children}
    </Modal>
  );
}

Sheet.Header = SheetHeader;
Sheet.Body = SheetBody;
Sheet.Footer = SheetFooter;
Sheet.ActionsPortal = Modal.ActionsPortal;
